import { EmployeeData } from '../models/EmployeeData';

export const handleFindMax = (employeeData: EmployeeData[]) => {
  return (
    employeeData?.reduce((max, employee) => {
      return Math.max(max, employee.count);
    }, 0) || 0
  );
};
